import React from 'react'
import { Link } from 'react-router-dom';

import "./Navbar.css"
import Langselect from './Langselect';
import { useTranslate, useLanguage } from '../Context/LanguageContext';
import MobileNavbar from './MobileNavbar';

const Navbar = () => {
    const t = useTranslate("navbar")
    const { ForChina, ForRegular} = useLanguage()

    return ( 
        <nav>
            <div className='wrapper logo-wrapper'>

                <div className='nav-section logo'>
                    <Link to="/">
                        <img src="./images/logo3.svg" alt="SINIS GmbH Logo" width="40" height="40" />
                        
                          <p>SINIS</p>  
                    </Link>
                </div>

                <ForRegular>
                    <div className='nav-section links'>
                        <Link to="/invest">        {t("invest")}       </Link>
                        <Link to="/purchase">      {t("purchase")}     </Link>
                        <Link to="/distribution">      {t("distribution")} </Link>
                        <span/>
                        <Link to="/recruitment">   {t("professionals")}</Link>
                        <span/>
                        <Link to="/about">         {t("about")}        </Link>
                        
                    </div>
                </ForRegular>

                <ForChina>
                    <div className='nav-section links'>
                        <Link to="/visa-consulting">        德国签证与移民       </Link>
                        <Link to="/business">      德国商务与投资     </Link>
                        <Link to="/international-trade">      中欧国际贸易 </Link>
                    </div>
                </ForChina>

            </div>


            <div className='wrapper misc-wrapper'>

                <MobileNavbar/>

                <ForRegular>
                    <Link to="/contact" className='nav-section contact'>
                        {t("contact")}
                    </Link>
                </ForRegular>

                <ForChina>
                    <Link to="/contact" className='nav-section contact'>
                        联系我们
                    </Link>
                </ForChina>

                <Langselect/>

            </div>

            

        </nav> 
    );
}
 
export default Navbar;